import type { Event } from '@kalos/kalos-rpc';

export const returnCorrectTimeField = (time: string) => {
  const splitString = time.split(' ');
  const timeValue = splitString[1].split(':');
  const hoursString = timeValue[0];
  const minutesString = timeValue[1];
  return `${hoursString}:${minutesString}`;
};
export const returnLegacyDate = (time: string) => {
  const splitString = time.split(' ');

  return `${splitString[0]} 00:00:00`;
};

const maskNameToCamelKey = (maskName: string) =>
  maskName.charAt(0).toLowerCase() + maskName.slice(1);

const normalizeLogTechnicianAssigned = (csv: string | undefined): string =>
  (csv ?? '')
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean)
    .map((s) => Number(s))
    .filter((id) => id !== 0 && !Number.isNaN(id))
    .sort((a, b) => a - b)
    .join(',');

const stringOrNumberFieldsEqual = (maskName: string, va: unknown, vb: unknown): boolean => {
  const numericMasks = new Set([
    'DepartmentId',
    'JobTypeId',
    'JobSubtypeId',
    'SoldBy',
    'CallbackTechnician',
    'CallbackCommentBy',
    'LeadGeneratedBy',
    'CallbackOriginalId',
    'IsCallback',
    'IsLmpc',
    'HighPriority',
  ]);
  if (numericMasks.has(maskName) || typeof va === 'number' || typeof vb === 'number') {
    return Number(va ?? 0) === Number(vb ?? 0);
  }

  return String(va ?? '').trim() === String(vb ?? '').trim();
};

const eventFieldValuesEqualForMask = (maskName: string, a: Event, b: Event): boolean => {
  if (maskName === 'LogTechnicianAssigned') {
    return (
      normalizeLogTechnicianAssigned(a.logTechnicianAssigned) ===
      normalizeLogTechnicianAssigned(b.logTechnicianAssigned)
    );
  }

  const key = maskNameToCamelKey(maskName);
  const va = (a as unknown as Record<string, unknown>)[key];
  const vb = (b as unknown as Record<string, unknown>)[key];
  return stringOrNumberFieldsEqual(maskName, va, vb);
};

/**
 * Removes `field_mask` entries where `next` matches `previous` for that field.
 * Use after building an update from form dirtyFields so activity logs omit unchanged values.
 */
export const filterEventFieldMaskToChangedFields = (
  fieldMask: string[],
  previous: Event,
  next: Event,
): string[] => fieldMask.filter((m) => !eventFieldValuesEqualForMask(m, previous, next));
